import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

const LABELS = { processing: 'extraction en cours', done: 'terminé', error: 'erreur', uploading: 'téléversement', downloading: 'téléchargement depuis le portail BCE' };
const FILES = ['activity.csv', 'enterprise.csv', 'address.csv', 'denomination.csv', 'contact.csv'];
const fmt = (n) => (typeof n === 'number' ? n.toLocaleString('fr-BE') : '–');

export const KboImportStatus = ({ state }) => {
  const [open, setOpen] = useState(false);
  if (!state?.status) return null;
  const d = state.diagnostics || {};
  const hasDiag = Object.keys(d).length > 0;
  return (
    <div className="space-y-1">
      <p className="text-xs text-[#6B7280]" data-testid="kbo-open-data-status">
        État : <strong>{LABELS[state.status] || state.status}</strong>
        {state.stage && (state.status === 'processing' || state.status === 'downloading') ? ` — ${state.stage}` : ''}
        {state.status === 'done' && state.source === 'auto' ? ' · import automatique' : ''}{state.status === 'done' && state.extract_number ? ` · extrait n° ${state.extract_number}` : ''}
        {state.status === 'error' && state.error ? <span className="text-red-600"> — {state.error}</span> : ''}
        {state.status === 'done' ? ` · ${fmt(state.count)} entreprises (${fmt(state.with_capacity)} avec capacités, ${fmt(state.architects)} architectes) · ${state.finished_at ? new Date(state.finished_at).toLocaleString('fr-BE') : ''}` : ''}
        {state.extract_date ? ` · extrait BCE du ${state.extract_date}` : ''}
      </p>
      {hasDiag && (
        <div>
          <button type="button" onClick={() => setOpen((o) => !o)} className="text-xs text-[#1E3A8A] inline-flex items-center gap-1 hover:underline" data-testid="kbo-diagnostics-toggle">
            {open ? <ChevronDown className="w-3 h-3" /> : <ChevronRight className="w-3 h-3" />} Diagnostic de l'extraction
          </button>
          {open && (
            <div className="mt-1 rounded border border-gray-200 bg-white p-2 text-[11px] text-[#4B5563] space-y-1" data-testid="kbo-diagnostics">
              <p>Groupe « capacités entrepreneuriales » : <code>{d.capacity_group || '–'}</code> · libellés NACE chargés : {fmt(d.nace_labels)}</p>
              {d.zip_members && <p>Fichiers du ZIP : {d.zip_members.map((m) => `${m.name} (${Math.round(m.size / 1048576)} Mo)`).join(', ')}</p>}
              {FILES.filter((f) => d[f]).map((f) => (
                <p key={f}><strong>{f}</strong> : {fmt(d[f].rows)} lignes{d[f].matches !== undefined ? ` → ${fmt(d[f].matches)} correspondance(s)` : ''}{d[f].headers?.length ? ` · colonnes : ${d[f].headers.join(', ')}` : ''}</p>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
